import * as CoreFns from './CoreFns';

export function searchFrontEnd(currentList){
	var t = ['fe', 'pu'];
	t.forEach((aT, index)=>{
		var fe = currentList[aT];
		var feKeys = Object.keys(fe);
		for (var i = 0; i < feKeys.length; i++){
			searchPage(fe[feKeys[i]])
		}
	})
}

export function getText(itemT, item){
	if (itemT === 'PANEL'){
		searchPanel(item);
	}else if (itemT === 'ALERT'){
		searchAlert(item);
	}else if (itemT === 'FOOTER'){
		searchFooter(item);
	}else if (itemT === 'navBar'){
		searchNavBar(item);
	}else if (itemT === 'fe' || itemT === 'pu'){
		searchPage(item);
	}else{
		searchItem(item);
	}
}

export function searchPage(page){
	searchNavBar(page.nv);
	var screenSet = page._s;
	var screenKeys = Object.keys(screenSet);
	for (var k = 0; k < screenKeys.length; k++){
		var thisPanel = screenSet[screenKeys[k]];
		searchPanel(thisPanel);
	}

}

function searchFooter(footer){
	return searchCollection(footer.i);
}

function searchNavBar(nv, thisScreenPath, entityType, currentList){
	// if (nv.on){
	// 	if (nv.on === 1){
	// 	}else{
	// 		thisScreenPath = ['cn', nv.on, 'nv'];
	// 		nv = CoreFns.goDownPath(currentList, thisScreenPath);
	// 	}
	// 	searchCollection(nv.i);
	// 	if (nv.navbarCluster){
	// 		searchCollection(nv.ic);
	// 		searchCollection(nv.ir);
	// 	}
	// }
	// return false;
}


function searchPanel(thisPanel){
	var alerts = thisPanel.al;
	var alertKeys = Object.keys(alerts);
	for (var i = 0; i < alertKeys.length; i++){
		var thisAlert = alerts[alertKeys[i]];
		searchAlert(thisAlert);
	}

	var kPages = thisPanel.k;
	var kPageKeys = Object.keys(kPages);
	for (var i1 = 0; i1 < kPageKeys.length; i1++){		
		var thisKPage = kPages[kPageKeys[i1]];
		searchCollection(thisKPage.i);
	}

	var iPages = thisPanel.i;
	var iPageKeys = Object.keys(iPages);
	for (var i2 = 0; i2 < iPageKeys.length; i2++){		
		var thisIPage = iPages[iPageKeys[i2]];
		searchCollection(thisIPage.i);
	}
}

function searchAlert(thisAlert){
	searchCollection(thisAlert.k);
}

function searchThroughItemX(itemX){
	var pieces = [];
	for (var i = 0; i < itemX.length; i++){
		var anItem = itemX[i];
		if (anItem.t === 't'){
			var vv = anItem.v;
			for (var j = 0; j < vv.length; j++){
				pieces.push({t:'t', v:vv.substr(j, 1), s:anItem.s});
			}
		}else{
			pieces.push(anItem);
		}
	}
	return pieces;
}

function searchItem(thisItem){
	var tt = thisItem.t;
	if (CoreFns.isHolder(tt)){
		searchCollection(thisItem.i);
	}else if (CoreFns.gotTextX(tt)){
		thisItem.x = searchThroughItemX(thisItem.x);
	}else if (tt === 'BUTTON' || tt === 'ICON' || tt === 'SPACE' || tt === 'INPUT' || tt === 'VIDEO' || tt === 'IMG' || tt === 'navBrand' || tt === 'navLink' || tt === 'GALLERY' || tt === 'TIMER' || tt === 'LINECHART' || tt === 'BARCHART' || tt === 'PIECHART'){
	}else{
		console.warn(thisItem);
	}

}

function searchCollection(items){
	if (items){
		var itemKeys = Object.keys(items);
		for (var j = 0; j < itemKeys.length; j++){
			var thisItemKey = itemKeys[j];
			var thisItem = items[thisItemKey];
			searchItem(thisItem);
		}		
	}

}